"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carbonDioxide = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const tsdb_1 = require("../tsdb");
const VariableName_1 = require("../VariableName");
exports.carbonDioxide = {
    __basic_data_type: true,
    __slotted_variable_name_data_type: true,
    __tsdb_data_type: true,
    __variable_name_data_type: true,
    id: 'carbonDioxide',
    variableName: VariableName_1.VariableName.carbonDioxide,
    dbTable: tsdb_1.TSDBTable.carbonDioxide,
    title: 'CO₂',
    icon: free_solid_svg_icons_1.faSmog,
    isSlotted: true,
    order: 6,
    graphQLSampleKey: 'cO2',
    bucketing: {
        min: 400,
        max: 1000,
        numberOfBuckets: 6,
    },
    colormap: [
        { value: 0, rgb: [0, 255, 0, 1] },
        { value: 800, rgb: [255, 204, 0, 1] },
        { value: 1000, rgb: [255, 0, 0, 1] },
    ],
    unit: `ppm`,
    dataPointConverter: x => x,
    decimals: 1,
};
//# sourceMappingURL=carbon-dioxide.js.map